import React from "react";
import "../Styles/UseCase.scss";
import { useNavigate } from "react-router-dom";
import EngageAIContent from "./Products/EngageAI/EngageAIContent";
import { motion } from "framer-motion";
import { Sparkles, Check, ArrowRight } from "lucide-react";

// Framer Motion Stagger Variants
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.05,
    },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 28, scale: 0.96 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.4,
      ease: [0.16, 1, 0.3, 1],
    },
  },
};

export default function Usecase({ content }) {
  const navigate = useNavigate();

  const useCases =
    Array.isArray(content) && content.length
      ? content
      : EngageAIContent.usecase || [];

  const handleExploreSolution = (useCase) => {
    if (useCase.url) {
      navigate(useCase.url);
    } else {
      navigate("/login");
    }
  };

  return (
    <div className="usecase-wrapper">
      <section className="usecase-section">
        {/* Apple Editorial Header Meta */}
        <div className="usecase-header-meta">
          <span className="usecase-label-apple">USE CASES</span>
          <h2 className="usecase-main-title">Engineered for Enterprise Impact</h2>
          <p className="usecase-main-sub">
            Discover how our specialized AI agents solve complex operational challenges across industries.
          </p>
        </div>

        {/* Apple Spatial Ceramic Industry Cards Grid with Staggered Entrance */}
        <div className="usecase-container">
          <motion.div
            className="usecase-grid"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            {useCases.map((useCase, index) => (
              <motion.div
                className="usecase-card"
                key={useCase.industry + index}
                variants={cardVariants}
              >
                {/* Industry Header Row */}
                <div className="usecase-card-header">
                  <div className="usecase-icon-stage">
                    <Sparkles size={18} />
                  </div>
                  <h3 className="usecase-industry-title">{useCase.industry}</h3>
                </div>

                {/* Points Checklist */}
                <ul className="usecase-features-list">
                  {useCase.points?.map((point, idx) => (
                    <li key={idx} className="usecase-feature-item">
                      <div className="usecase-check-icon">
                        <Check size={14} />
                      </div>
                      <span className="usecase-point-text">{point}</span>
                    </li>
                  ))}
                </ul>

                {/* Apple Link CTA Footer */}
                <div className="usecase-card-footer">
                  <div
                    className="usecase-link-btn"
                    onClick={() => handleExploreSolution(useCase)}
                    style={{ cursor: "pointer" }}
                  >
                    <span>Explore Solution</span>
                    <ArrowRight size={15} className="usecase-btn-arrow" />
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>
    </div>
  );
}
